import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export const addNonVisualizedProduct = (set, get, skuToAdd) => {
  const state = get();

  // FIX: Add a guard clause to prevent crashes during initialization
  // and use the correct path to access the cart.
  if (!state?.designs?.[state.selectedDesignId]) {
    return;
  }

  const currentDesign = state.designs[state.selectedDesignId];
  const cartFromState = currentDesign.Cart || [];

  const existingItemIndex = cartFromState.findIndex((item) => item.Sku === skuToAdd);
  let updatedCart;

  if (existingItemIndex > -1) {
    // Item exists, so we correctly increment its quantity.
    updatedCart = cartFromState.map((item, index) => {
      if (index === existingItemIndex) {
        return { ...item, Quantity: item.Quantity + 1 };
      }
      return item;
    });
  } else {

    updatedCart = [...cartFromState, { Sku: skuToAdd, Quantity: 1 }];
  }

  // FIX: Use the correct path to set the new state.
  set({
    designs: {
      ...state.designs,
      [state.selectedDesignId]: {
        ...currentDesign,
        Cart: updatedCart,
      },
    },
  }, false, { type: 'ADD_NON_VISUALIZED_PRODUCT', payload: { sku: skuToAdd } });

  const newRelicPayload = {
    updatedAccessories: skuToAdd
  };

  logNewRelicCustom(NEW_RELIC_EVENTS.NON_VISUALIZED_PRODUCT_ADDED, newRelicPayload);
};
